<div>
    <div class="content">
        <list-view #listeViewOpeCarte [liste]="listeOpeCarte" *ngIf="listeOpeCarte"></list-view>
    </div>
    <floating-button *ngIf="listeActions?.value" [listeActions]="listeActions"></floating-button>
</div>